export enum IntegrationAccessStates {
    NoAction = 0,
    NoAccess = 1,
    HasAccess = 2,
}